export const deletable = (entity) => {
  return (entity?.children || [])?.length === 0 && !entity.is_used;
};

